module.exports = __webpack_public_path__ + "static/banner-round-bg-ebf4547100393cb4133cdc8f8dc19996.png";